import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '../../context/DataContext';
import './activity-reminder-banner.css';

const DAYS_THRESHOLD = 14;

export default function ActivityReminderBanner() {
  const { activities } = useContext(DataContext);
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('lightway-activity-reminder-dismissed') === 'true'
  );

  if (dismissed) return null;
  if (!activities || activities.length === 0) return null;

  // activities are ordered by timestamp desc — first one is most recent
  const latest = activities[0];
  const latestDate = latest.timestamp?.toDate
    ? latest.timestamp.toDate()
    : new Date(latest.timestamp);
  const daysSince = Math.floor((Date.now() - latestDate.getTime()) / (1000 * 60 * 60 * 24));

  if (daysSince < DAYS_THRESHOLD) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('lightway-activity-reminder-dismissed', 'true');
    setDismissed(true);
  };

  return (
    <div className="activity-reminder">
      <p className="activity-reminder-text">
        It's been a while! Ready to log your next advocacy action?
      </p>
      <div className="activity-reminder-actions">
        <button className="activity-reminder-btn" onClick={() => navigate('/log-activity')}>
          Log Activity
        </button>
        <button className="activity-reminder-dismiss" onClick={handleDismiss}>
          Dismiss
        </button>
      </div>
    </div>
  );
}
